import { render, staticRenderFns } from "./ClvrConfigElementList.vue?vue&type=template&id=c01cab70"
import script from "./ClvrConfigElementList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClvrConfigElementList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClvrConfigElementList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports